import { render, staticRenderFns } from "./supInforme.vue?vue&type=template&id=40d9051e&scoped=true&"
import script from "./supInforme.vue?vue&type=script&lang=js&"
export * from "./supInforme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d9051e",
  null
  
)

export default component.exports